import React from "react";
import sevakimg from './assets/sevak-img.webp';
import becomeNityaSevak from './assets/becomeNityaSevak.webp'

import './NityaSevaCard.css';

const NityaSevaSection = () => {
  return (
    <div 
      className="nitya-seva-container  " 
      style={{
        backgroundImage: `url(${becomeNityaSevak})`,
        backgroundSize: 'contain', 
        backgroundRepeat: 'no-repeat'
      }}
    >
      <img 
        src={sevakimg} 
        alt="Seva background" 
        className="nitya-seva-image"
      />
      
      <div className="nitya-seva-content">
        <ul className="nitya-seva-bulletpoints">
          <li>
            Nitya seva is our monthly recurring donation program, where devotees contribute an amount of their choice on the date of their choice as per their capacity. They can also stop this whenever they want.
          </li>
          <li>
            Their contribution utilized by the temple in several services like Deities personal seva, prasadam distribution, altar decoration, preaching, etc. as per the need.
          </li>
          <li>
            Volunteer charity is always the most important method to financially support spiritual causes in this world.
          </li>
        </ul>
      </div>
    </div>
  );
};

export default NityaSevaSection;